import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiPaperOverrides = {
  defaultProps?: ComponentsProps['MuiPaper'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiPaper'];
  variants?: ComponentsVariants['MuiPaper'];
}

function getMuiPaperOverride(): MuiPaperOverrides {
  return {
    defaultProps: {
      elevation: 0
    }
  }
}

export default getMuiPaperOverride;